import React from 'react';
import './FAQ.css'

function FAQ() {
  return (
    <section className="faq-section">
      <h2>Frequently Asked Questions (FAQ)</h2>
      <div className="faq-item">
        <h3>What is DevToolkitHub?</h3>
        <p>
          DevToolkitHub is an online collection of developer tools designed to simplify various
          coding and data transformation tasks. From encoding and decoding to data formatting,
          these tools are crafted to make developers’ work faster and easier.
        </p>
      </div>
      <div className="faq-item">
        <h3>How do I use the JSON Formatter?</h3>
        <p>
          Our JSON Formatter lets you easily format and beautify raw JSON data. Simply paste your JSON
          code into the input box and click the "Format JSON" button to view it in a more readable format.
          This tool is particularly useful for debugging and cleaning up JSON responses from APIs.
        </p>
      </div>
      <div className="faq-item">
        <h3>What is the Base64 Encoder/Decoder for?</h3>
        <p>
          The Base64 Encoder/Decoder is a tool for encoding data into Base64 format and decoding Base64
          back to its original form. It’s commonly used for encoding binary data to text for APIs, data
          URLs, and more.
        </p>
      </div>
      <div className="faq-item">
        <h3>Can I use these tools on my mobile device?</h3>
        <p>
          Yes, DevToolkitHub is mobile-friendly, allowing you to access all tools on any device with
          internet connectivity. The site is responsive, so the layout will adjust to provide an optimal
          experience on smaller screens.
        </p>
      </div>
      <div className="faq-item">
        <h3>Are my data and inputs secure?</h3>
        <p>
          Absolutely! DevToolkitHub operates entirely in the browser, meaning no data is sent to the server.
          Your inputs are secure, as everything happens on the client side. We prioritize your privacy and
          ensure that no data leaves your device.
        </p>
      </div>
      <div className="faq-item">
        <h3>What is the JAM Encoder/Decoder?</h3>
        <p>
          The JAM Encoder/Decoder is a fun and unique tool that encodes text by converting each character
          to a base36 format with a dot separator. You can also decode a JAM string back to its original text.
          It’s especially useful for creating obfuscated but reversible text representations.
        </p>
      </div>
      <div className="faq-item">
        <h3>Why should I use DevToolkitHub?</h3>
        <p>
          DevToolkitHub offers a range of easy-to-use, efficient tools for developers. With no installation
          required and a simple interface, it allows you to get your tasks done quickly, saving you time and
          effort in development, debugging, and data transformation.
        </p>
      </div>
    </section>
  );
}

export default FAQ;
